import * as Sentry from '@sentry/browser'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import { Provider } from 'react-redux'
import { hydrate, render } from 'react-dom'

import store from 'store'
import { isPreRendering } from 'ui-component-library/utils/helpers'
import MainApp from 'containers/App'
import 'ui-component-library/stylesheets/reset.scss'
import 'ui-component-library/stylesheets/base.scss'

const SENTRY_DSN = process.env.SENTRY_DSN
const SENTRY_ENV = process.env.SENTRY_ENV

if (SENTRY_DSN && !isPreRendering() && process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: SENTRY_DSN,
    release: `cms-frontend@${process.env.npm_package_version}`,
    environment: SENTRY_ENV,
  })
}

if (typeof window.IntersectionObserver === 'undefined' && !isPreRendering()) {
  require('intersection-observer')
}

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Route component={MainApp} path='/' />
      </Router>
    </Provider>
  )
}

const appElement = document.getElementById('app')

if (appElement && appElement.hasChildNodes()) {
  hydrate(<App />, appElement)
} else {
  render(<App />, appElement)
}
